export default __webpack_public_path__ + "static/Adobe_Workfront_lockup_no_shadow_reversed_0-1a08744c2eb317706446fa00da23a3be.png";